"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LLM_MODELS = exports.AILLMProviders = void 0;
var AILLMProviders;
(function (AILLMProviders) {
    AILLMProviders["OpenAI"] = "openai";
    AILLMProviders["Gemini"] = "gemini";
    AILLMProviders["Anthropic"] = "anthropic";
})(AILLMProviders || (exports.AILLMProviders = AILLMProviders = {}));
exports.DEFAULT_LLM_MODELS = {
    [AILLMProviders.OpenAI]: "gpt-4-turbo",
    [AILLMProviders.Gemini]: "gemini-2.5-flash",
    [AILLMProviders.Anthropic]: "claude-sonnet-4-5-20250929",
};
